export class ExternalErrorCode {
  private static namespace = 'Unistocks.External';

  public static NoProviderData = `${this.namespace}:0001`;
}
